import { isSignalTypeKey, partitionBySignalKeys } from "app/pages/sales-intelligence/domain/signals/utils/signal-key";

import { resolveStateReset } from "../store/utils/resolvers";
import type { ILeadsSearchFiltersDto, LeadsSearchAllFiltersTypes } from "../types/leadsSearchFilters.dto";

import { leadsFilterDtoToPanelValue, leadsFilterPanelValueToDto } from "./leadsFilterDtoAdapters";

/**
 * Resolves a leads filter panel value after an update, applying the same reset rules as the
 * leads-search-filters redux reducer (`resolveStateReset`). Signal-type keys are preserved
 * without DTO round-tripping.
 */
export const resolveLeadsFilterPanelValue = (
    currentPanelValue: Partial<LeadsSearchAllFiltersTypes>,
    nextPanelValue: Partial<LeadsSearchAllFiltersTypes>,
): Partial<LeadsSearchAllFiltersTypes> => {
    const { rest: nextRest } = partitionBySignalKeys(nextPanelValue);
    const { rest: currentRest } = partitionBySignalKeys(currentPanelValue);

    const currentDto = leadsFilterPanelValueToDto(currentRest);
    const nextDto = leadsFilterPanelValueToDto(nextRest);
    const resolvedRest = leadsFilterDtoToPanelValue(resolveStateReset(currentDto, nextDto));

    const signalEntries = Object.entries(nextPanelValue).filter(([key]) => isSignalTypeKey(key));

    return { ...resolvedRest, ...Object.fromEntries(signalEntries) };
};

/** DTO-level reset for panel values that are not backed by the leads-search-filters store. */
export const resolveLeadsFiltersDto = (
    dto: Partial<ILeadsSearchFiltersDto>,
    currentDto: Partial<ILeadsSearchFiltersDto> = {},
): Partial<ILeadsSearchFiltersDto> => resolveStateReset(currentDto, dto);
